;(function () {
  'use strict'

  angular.module('contrast.avatar').factory('avatarService', avatarService)

  function avatarService(ImageUploadAndCrop) {
    'ngInject'

    return {
      createAvatarPicker: createAvatarPicker
    }

    function createAvatarPicker(
      container,
      cropButton,
      onCrop,
      onUpload,
      onUploadError,
      onError
    ) {
      return new ImageUploadAndCrop(container, {
        cropButton: cropButton,
        onCrop: onCrop,
        onImageUpload: onUpload,
        onImageUploadError: onUploadError,
        onError: onError
      })
    }
  }
})()
